var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { parse as parseYaml } from 'yaml';
import { ModuleSpec as FilterSpecModule, ThemeSpec as FilterSpecTheme, SiteMetadataSpec, } from './FilterTypesSpec';
import { ModuleSpec, ThemeSpec } from './UiTypesSpec';
export var parseModule = function (moduleId, comment) {
    var declarationContent = comment.substring(comment.indexOf('\n'), // chop the structured declaration
    comment.indexOf('*/'));
    var module = parseYaml(declarationContent);
    return ModuleSpec.parse(__assign(__assign({}, FilterSpecModule.parse(module)), { id: moduleId, rs2f: '' }));
};
export var parseTheme = function (id, comment) {
    var declarationContent = comment.substring(comment.indexOf('\n'), // chop the structured declaration
    comment.indexOf('*/'));
    var module = parseYaml(declarationContent);
    return ThemeSpec.parse(__assign(__assign({}, FilterSpecTheme.parse(module)), { id: id }));
};
export var parseSiteMetadata = function (comment) {
    var content = comment.substring(comment.indexOf('\n'), comment.indexOf('*/'));
    var meta = parseYaml(content);
    return SiteMetadataSpec.parse(meta);
};
